import React from "react";
import "./ParentSubScoreItem.scss";
import ParentScoreItemStatusBlock from "./ParentScoreItemStatusBlock";
import ParentPeopleLevels from "./ParentPeopleLevels";
import { isNotNullOrUndefined } from "../../../../../services/util";
import { useTranslation } from "react-i18next";

const ParentSubScoreItem = ({ name, values }) => {
  const { t } = useTranslation(['teacher_parent_report'])

  if(!values) return null;
  if(!isNotNullOrUndefined(values.percentile)) return null; // do not render if no data

  const { percentile, color, pacing, label } = values;

  return (
    <div className="parent-columned-layout parent-subscore-item">
      <div className="__value parent-subscore-item-name"><h3>{name}</h3></div>
      <div className="__value parent-subscore-item-percentile">
        <ParentPeopleLevels percentage={percentile} />
      </div>
      <div className="__value parent-subscore-item-status">
        <ParentScoreItemStatusBlock color={color} pacing={pacing} />
      </div>
      <div className="__value parent-subscore-item-description">{t(`domain_descriptions.${label}`)}</div>
    </div>
  )
}

export default ParentSubScoreItem